var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeliveryinline = function SvgDeliveryinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 15"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#21201F",
    clipPath: "url(#delivery_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.736 12.387v-.857a.43.43 0 0 0 .407-.407V7.52a.67.67 0 0 0-.171-.429l-3.595-3.984a.68.68 0 0 0-.492-.219H13.11v7.896h-.857V2.01h2.652a1.53 1.53 0 0 1 1.127.501l3.599 3.985c.251.28.39.643.39 1.02v3.607a1.285 1.285 0 0 1-1.286 1.264M1.405 12.31H0V0h12.926v.857H.856v10.595h.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.57 6.73h-4.207v.857h4.208zM4.399 14.12a2.24 2.24 0 1 1 0-4.482 2.24 2.24 0 0 1 0 4.482m0-3.624a1.384 1.384 0 1 0 1.384 1.383 1.384 1.384 0 0 0-1.384-1.362zM15.792 14.12a2.24 2.24 0 1 1 0-4.481 2.24 2.24 0 0 1 0 4.481m0-3.624a1.384 1.384 0 1 0 1.383 1.383 1.39 1.39 0 0 0-1.383-1.362z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.975 11.451H7.287v.857h6.688z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "delivery_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v14.122H0z"
  })))));
};
export default SvgDeliveryinline;